import { Chip, Tooltip } from "@mui/material";
import {
  LogSearchKind,
  PauseReason,
  Role,
  Task,
} from "../../../app/backendTypes";
import { useAppSelector } from "../../../app/hooks";
import { ChipColor } from "../../../app/utils";
import { useNavigate } from "react-router-dom";

function TaskStatus(props: { task: Task }) {
  const { task } = props;

  const status = task.status;

  let label: string = status.kind;
  let color: ChipColor = "default";
  let disabled = false;
  let onClick = undefined;

  const isAdmin = useAppSelector((state) =>
    state.auth.roles.includes(Role.Administrator)
  );

  const navigate = useNavigate();

  switch (status.kind) {
    case "Idle": {
      break;
    }

    case "Running": {
      color = "secondary";
      break;
    }

    case "Paused": {
      switch (status.inner.reason) {
        case PauseReason.WaitingForApproval: {
          label = "Waiting for approval";
          break;
        }

        case PauseReason.WaitingForSupport: {
          label = "Waiting for support";
          break;
        }
      }

      color = "secondary";

      break;
    }

    case "Error": {
      color = "error";

      if (isAdmin) {
        onClick = () =>
          navigate(`/admin/logs?kind=${LogSearchKind.Task}&value=${task.id}`);
      }

      break;
    }

    case "Done": {
      color = "success";
      break;
    }

    case "Cancelled": {
      if (status.inner.reason.kind === "ApprovalDenied") {
        label = "Denied";
      }

      if (status.inner.reason.kind === "SupportTicketCancelled") {
        label = "Support ticket cancelled";
      }

      disabled = true;

      break;
    }
  }

  const chip = (
    <Chip
      label={label}
      color={color}
      disabled={disabled}
      variant="outlined"
      onClick={onClick}
    />
  );

  return isAdmin ? (
    <>{chip}</>
  ) : (
    <Tooltip arrow placement="top" title={props.task.id}>
      <span>{chip}</span>
    </Tooltip>
  );
}

export default TaskStatus;
